import React from 'react';
import {Navigate, Route, Routes} from 'react-router-dom';
import NewsPage from '../pages/NewsPage';
import NewsDetail from '../components/News/NewsDetail';
import ClusterDetail from '../components/News/ClusterDetail';
import TrendingPage from '../pages/TrendingPage';
import TagSearchPage from '../pages/TagSearchPage';
import SearchPage from '../pages/SearchPage';
import ContactPage from '../pages/ContactPage';
import PrivacyPolicyPage from '../pages/PrivacyPolicyPage';
import LoginPage from '../pages/LoginPage';
import RegisterPage from '../pages/RegisterPage';
import UserPreferencesPage from '../pages/UserPreferencesPage';
import ReadLaterPage from '../pages/ReadLaterPage';
import PersonalizedNewsPage from '../pages/PersonalizedNewsPage';
import ProfilePage from '../pages/ProfilePage';
import SettingsPage from '../pages/SettingsPage';
import AuthSuccess from '../pages/AuthSuccess';
import AuthError from '../pages/AuthError';
import EmailVerification from '../pages/EmailVerification';
import ResetPasswordPage from '../pages/ResetPasswordPage';
import ForgotPasswordPage from '../pages/ForgotPasswordPage';
import ChangePasswordPage from '../pages/ChangePasswordPage';
import {USE_USER} from '../config/features';

const AppRoutes: React.FC = () => {
  return (
    <Routes>
      <Route path="/" element={<NewsPage />} />
      <Route path="/news/:id" element={<NewsDetail />} />
      <Route path="/news/cluster/:clusterId" element={<ClusterDetail />} />
      <Route path="/cluster/:clusterId" element={<ClusterDetail />} />
      <Route path="/search" element={<SearchPage />} />
      <Route path="/trending" element={<TrendingPage />} />
      {/* Legacy redirects */}
      <Route path="/breaking" element={<Navigate to="/" replace />} />
      <Route path="/hot" element={<Navigate to="/trending" replace />} />
      <Route path="/tags" element={<TagSearchPage />} />
      <Route path="/contact" element={<ContactPage />} />
      <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
      {/* Password reset routes — always available for existing users */}
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/change-password" element={<ChangePasswordPage />} />
      <Route path="/auth/verify-email" element={<EmailVerification />} />
      {USE_USER && (
        <>
          <Route path="/preferences" element={<UserPreferencesPage />} />
          <Route path="/read-later" element={<ReadLaterPage />} />
          <Route path="/personalized" element={<PersonalizedNewsPage />} />
          <Route path="/personalized/:groupId" element={<PersonalizedNewsPage />} />
          <Route path="/profile" element={<ProfilePage />} />
          <Route path="/settings" element={<SettingsPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/auth/success" element={<AuthSuccess />} />
          <Route path="/auth/error" element={<AuthError />} />
        </>
      )}
      {!USE_USER && (
        <>
          <Route path="/login" element={<Navigate to="/" replace />} />
          <Route path="/register" element={<Navigate to="/" replace />} />
          <Route path="/profile" element={<Navigate to="/" replace />} />
          <Route path="/settings" element={<Navigate to="/" replace />} />
          <Route path="/preferences" element={<Navigate to="/" replace />} />
          <Route path="/read-later" element={<Navigate to="/" replace />} />
          <Route path="/personalized" element={<Navigate to="/" replace />} />
          <Route path="/personalized/:groupId" element={<Navigate to="/" replace />} />
          <Route path="/auth/success" element={<Navigate to="/" replace />} />
          <Route path="/auth/error" element={<Navigate to="/" replace />} />
        </>
      )}
    </Routes>
  );
};

export default AppRoutes;
